<template>
  <div>
    <Nav />

    <div class="page">
      <OnlineStatus />

      <Header />

      <main class="main">
        <slot />
      </main>

      <!-- <Footer /> -->
    </div>
  </div>
</template>

<script>
import Nav from './Nav'
import Header from './Header'
import OnlineStatus from './OnlineStatus'
// import Footer from './Footer'

import { mapGetters } from 'vuex'

export default {
  components: { Nav, Header, OnlineStatus },
  computed: {
    ...mapGetters({
      abilities: 'user/definedAbilities',
    }),
  },
  mounted() {
    this.getUnsolvedCount()
    this.getUnlinkedCount()
  },
  methods: {
    getUnsolvedCount() {
      if (!this.abilities) return
      if (!this.abilities.can('read', 'logs')) return

      this.$store.dispatch('logs/getUnsolvedCount')
    },
    getUnlinkedCount() {
      if (!this.abilities) return
      if (!this.abilities.can('read', 'payments')) return

      this.$store.dispatch('payments/getUnlinkedCount')
    },
  },
}
</script>

<style lang="scss" scoped>
.page {
  min-height: 100vh;
  padding: 0;

  @include media_tablet() {
    padding: 0 0 0 $headerHeight;
  }

  @include createFlex(flexbox, nowrap, column, flex-start, stretch, stretch);
}

.main {
  width: 100%;
  min-height: calc(100vh - #{$headerHeight});
  margin: 0;
  background: white;

  @include createFlex(flexbox, nowrap, column, flex-start, flex-start, flex-start);
}
</style>
